import { render, staticRenderFns } from "./addResultat.vue?vue&type=template&id=478e460e"
import script from "./addResultat.vue?vue&type=script&lang=js"
export * from "./addResultat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports